<div class="transcript-entry">
  <div class="user-header">
    <glxy-avatar [src]="entry().user?.imgSrc" [name]="entry().user?.displayName" width="18" shape="square"></glxy-avatar>
    <div class="user-name">{{ entry().user?.displayName }}</div>
    @if (firstEntryStartTime() > 0) {
      <div class="timestamp">
        @if (firstEntryStartTime() < hourInSeconds) {
          {{ firstEntryStartTime() | secondsToDateSeconds | date: 'mm:ss' }}
        } @else {
          {{ firstEntryStartTime() | secondsToDateSeconds | date: 'hh:mm:ss' }}
        }
      </div>
    }
  </div>
  <div class="transcript-content">
    <glxy-transcript-contents
      [contents]="entry().content"
      (contentClicked)="clickedContent($event)"
    ></glxy-transcript-contents>
  </div>
</div>
